// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ActionIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ActionIcon" ref={forwardedRef} {...props}>
      <path d="m6.75 11 4.5-6-.668 4.001 2.667.005L8.75 15l.752-4z" />
      <path d="M1.996 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0m8 6.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ActionIcon = /* @__PURE__ */ Object.assign(ActionIconComponent, {
  displayName: 'ActionIcon',
});
